<template>
    <span class="brand-icon inline-flex" :style="colorStyle">
        <Icon :icon="resolvedIcon" />
    </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
    brand: string;
    colored?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    colored: false,
});

const brandMap: Record<string, string> = {
    // Browsers - Simple Icons
    chrome: 'brands/chrome',
    firefox: 'brands/firefox',
    safari: 'brands/safari',
    edge: 'brands/edge',
    ie: 'brands/ie',
    gmail: 'brands/gmail',
    thunderbird: 'brands/thunderbird',
    mozilla: 'brands/mozilla',

    // Platforms - Simple Icons
    windows: 'brands/windows',
    linux: 'brands/linux',
    android: 'brands/android',
    androidos: 'brands/android',
    ios: 'brands/apple',
    'os x': 'brands/apple',
    apple: 'brands/apple',
    macos: 'brands/apple',

    // Email - Simple Icons
    outlook: 'brands/outlook',

    // Devices - Phosphor (not brands)
    desktop: 'phosphor/regular/desktop',
    mobile: 'phosphor/regular/device-mobile',
};

const brandColors: Record<string, string> = {
    // Browsers
    chrome: '#4285F4',
    firefox: '#FF7139',
    safari: '#006CFF',
    edge: '#0078D7',
    ie: '#0076D6',
    gmail: '#EA4335',
    thunderbird: '#0A84FF',
    mozilla: '#000000',

    // Platforms
    windows: '#0078D4',
    linux: '#FCC624',
    android: '#34A853',
    androidos: '#34A853',
    ios: '#000000',
    'os x': '#000000',
    apple: '#000000',
    macos: '#000000',

    // Email
    outlook: '#0078D4',
};

const resolvedIcon = computed(() => {
    const key = props.brand.toLowerCase();
    return brandMap[key] ?? 'phosphor/regular/globe';
});

const colorStyle = computed(() => {
    if (!props.colored) return {};
    const color = brandColors[props.brand.toLowerCase()];
    return color ? { color } : {};
});
</script>
